<template>
  <main class="page-operative page-operative-project page-operative-project-library-costs page-operative-project-library-costs-list d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-start justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Costi figurati (libreria)</PageTitle>

        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.projects.library.imputedCosts.add' }">
          Aggiungi costo figurato (libreria)
        </app-router-link>
      </div>

      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <ImputedCostsListTable v-if="results" class="report-texts-size" :costi="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeCosto" />
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';
import loadingDataMixin from '@/mixins/loadingData';
import confirmWithModalMixin from '@/libs/Confirm/mixins/confirmWithModal';

export default {
  name: 'page-operative-company-project-library-costs-list',
  mixins: [operativePageMixin, loadingDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('@/views/components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('@/views/components/Operative/LoadingDataLoader'),
    ImputedCostsListTable: () => import('@/views/components/Operative/ListTable/ImputedCostsListTable'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  data () {
    return {
      data: null,
      results: null,
    };
  },
  methods: {
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.listImputedCosts(this.company?.id)
        .then(res => {
          this.results = res?.data?.costs || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeCosto (id) {
      this.confirm('Cancellare il costo figurato (libreria) selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteImputedCost(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.retrieveListData();
      },
    },
  },
};

</script>
